import * as React from 'react'
import { styled } from 'next-yak'

import * as behaviours from '../../../behaviours'
import * as breakpoints from '../../../constants/breakpoints'
import * as S from '../../../styles'

import { Field } from './Field'
import { FieldStatus } from './FieldStatus'
import { type PhoneInputProps, PhoneInput } from '../phone/PhoneInput'

export type PhoneFieldProps = Omit<PhoneInputProps, 'status'> & {
  id?: string
  label?: React.ReactNode
  context?: string
  description?: string
  error?: React.ReactNode
  success?: React.ReactNode
}

function PhoneFieldComponent({
  className,
  label,
  context,
  description,
  error,
  success,
  id = String(Math.random()),
  ...inputProps
}: PhoneFieldProps): React.ReactElement<PhoneFieldProps> {
  const { classList, status } = behaviours.getStatusClassName(className, error, success)

  return (
    <PhoneFieldWrapper
      className={classList.filter(Boolean).join(' ')}
      htmlFor={id}
      label={label}
      description={description}
      context={context}
    >
      <PhoneInput {...inputProps} id={id} status={status} />
      {(error || success) && <FieldStatus error={error} success={success} />}
    </PhoneFieldWrapper>
  )
}

/** extends `<PhoneInput>`, see there for additional props */
export const PhoneField = styled(PhoneFieldComponent)<PhoneFieldProps>``
PhoneField.displayName = 'PhoneField'

export const PhoneFieldWrapper = styled(Field)`
  ${S.field.Context} {
    margin-top: -2px;
    margin-bottom: 7px;

    @media screen and ${breakpoints.TABLET} {
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }

  ${S.field.Status} {
    margin-top: 10px;
  }

  ${S.field.Title}, ${S.field.Description} {
    margin-bottom: 7px;
  }
`
